import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Output,
    ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import { IUser } from '@shared/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserSettingsComponent } from '@shared/components/user-settings/user-settings.component';
import { GuardService, ThemeService } from '@shared/services';
import { ModuleDirective } from '@shared/directives/module.directive';
import { ModuleService } from '@shared/services/module.service';
import { ThemeMode } from '@shared/enums';
import { AuthService } from '@app/auth/services/auth.service';

@Component({
    selector: 'reporting-tool-user-menu',
    templateUrl: './reporting-tool-user-menu.component.html',
    styleUrls: ['./reporting-tool-user-menu.component.scss'],
    standalone: false
})
export class ReportingToolUserMenuComponent extends ModuleDirective implements AfterViewInit {
    subscription: Subscription;
    private dialogRef: MatDialogRef<UserSettingsComponent>;
    @Output() openFaq = new EventEmitter();
    visibleSection = 0;
    @ViewChild('userContainer') userContainer: ElementRef;
    minWidth = 0;
    protected isDarkMode = false;

    constructor(
        public guardService: GuardService,
        private translateService: TranslateService,
        private dialog: MatDialog,
        private authService: AuthService,
        private changeDetector: ChangeDetectorRef,
        moduleService: ModuleService,
        private themeService: ThemeService
    ) {
        super(moduleService);

        setInterval(() => {
            this.visibleSection = this.visibleSection === 0 ? 1 : 0;
        }, 0.2 * 60000);
    }

    get currentUser(): IUser {
        return this.guardService.currentUser;
    }

    get expirationTimeInMinutes(): number {
        return this.authService.expirationTimeInMinutes;
    }

    openDialog() {
        if (this.guardService.isAdmin || this.guardService.mainUser) {
            if (!this.dialogRef) {
                this.dialogRef = this.dialog.open(UserSettingsComponent, {
                    position: { top: '50px', right: '10px' },
                    minHeight: 'calc(100vh - 50px)',
                    panelClass: 'dialog-side-panel',
                    hasBackdrop: false
                });
                this.dialogRef.afterClosed().subscribe(() => (this.dialogRef = null));
            } else {
                const overlays = document.getElementsByClassName('dialog-side-panel');
                for (const overlay of Array.from(overlays)) {
                    overlays[overlays.length - 1].animate(
                        [{ transform: 'translateX(0)' }, { transform: 'translateX(510px)' }],
                        { duration: 300, iterations: 1 }
                    );
                }
                setTimeout(() => this.dialogRef.close(), 200);
            }
        }
    }

    ngAfterViewInit() {
        this.minWidth = this.userContainer.nativeElement.clientWidth;
        this.changeDetector.detectChanges();
    }

    protected switchTheme(): void {
        this.themeService.switchTheme();
        this.isDarkMode = this.themeService.theme === ThemeMode.Dark;
    }

    protected isLargeScreen(): boolean {
        return window.innerWidth >= 1440;
    }
}
